/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APICustomerContact
 */
export interface APICustomerContact {
    /**
     * 
     * @type {string}
     * @memberof APICustomerContact
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerContact
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerContact
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerContact
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof APICustomerContact
     */
    language?: string;
}

/**
 * Check if a given object implements the APICustomerContact interface.
 */
export function instanceOfAPICustomerContact(value: object): value is APICustomerContact {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function APICustomerContactFromJSON(json: any): APICustomerContact {
    return APICustomerContactFromJSONTyped(json, false);
}

export function APICustomerContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): APICustomerContact {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'language': json['language'] == null ? undefined : json['language'],
    };
}

export function APICustomerContactToJSON(value?: APICustomerContact | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'email': value['email'],
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'language': value['language'],
    };
}

